export default __webpack_public_path__ + "static/media/2324 utensils side.8521df17.png";